<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    mounted() {
      this.$store.dispatch('getProvinces')
      this.$store.dispatch('getSalaryList')
      this.$store.dispatch('getFoodBedList')
      this.$store.dispatch('getTrades')
      this.$store.dispatch('getEducations')
    }
  }
</script>

<style lang="scss">
</style>
